import { render, staticRenderFns } from "./select-white.vue?vue&type=template&id=2b40edb4&scoped=true"
import script from "./select-white.vue?vue&type=script&lang=js"
export * from "./select-white.vue?vue&type=script&lang=js"
import style0 from "./select-white.vue?vue&type=style&index=0&id=2b40edb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40edb4",
  null
  
)

export default component.exports